import Loading from "./loading.vue";
export default {
  /**
  * 每个插件都有的install方法，用于安装插件
  * @param {Object} Vue - Vue类
  * @param {Object} [pluginOptions] - 插件安装配置
  */
  install: function install(Vue) {
    var pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // 创建"子类"方便挂载
    var VueLoading = Vue.extend(Loading);
    var loading = null;
    /**
    * 初始化并显示loading
    * @returns {Promise} Promise实例
    */

    function $loading() {
      return new Promise(function (resolve) {
        // 第一次调用
        if (!loading) {
          loading = new VueLoading(); // 手动创建一个未挂载的实例

          loading.$mount(); // 挂载

          document.querySelector(pluginOptions.container || 'body').appendChild(loading.$el);
        } // 显示loading


        loading.show();
        resolve();
      });
    } // 定义关闭loading方法


    $loading.hide = function () {
      var noAnimate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (resolve) {
        if (!loading || !loading.isShow) {
          resolve();
          return;
        } // 首页判断是否在关闭时需要动画


        if (noAnimate) {
          // 默认只在此次行为下移除动画,之后的行为仍有动画
          loading.removeAnimate().then(function () {
            loading.opemAnimate();
          });
        }

        loading.hide();
      });
    };

    Vue.loading = Vue.prototype.$loading = $loading;
  }
};